import { Button, Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { green } from '@material-ui/core/colors';
import clsx from 'clsx';

import ProgressOverlay from './ProgressOverlay';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    float: 'left',
    marginTop: theme.spacing(1),
  },
  wrapper: {
    position: 'relative',
    alignItems: 'center',
    justify: 'center',
  },
  buttonSuccess: {
    backgroundColor: green[500],
    '&:hover': {
      backgroundColor: green[700],
    },
  }
}));

function ProgressButton({ loading, success, type, disabled, tooltip, ...props }) {
  const classes = useStyles();

  const buttonClassname = clsx({
    [classes.buttonSuccess]: success,
  });

  const button = (
    <Button
      variant="contained"
      color="primary"
      className={buttonClassname}
      type={type}
      disabled={disabled}
      disableElevation={true}
      {...props}
    >
      {props.children}
    </Button>
  );

  const overlayButton = (
    <div className={classes.root}>
      <div className={classes.wrapper}>
        {button}
        {loading && <ProgressOverlay size={24} />}
      </div>
    </div>
  );

  if (tooltip) {
    return (
      <Tooltip title={tooltip}>
        {overlayButton}
      </Tooltip>
    );
  } else {
    return (
      <>
        {overlayButton}
      </>
    );
  }
}

export default ProgressButton;
